export default __webpack_public_path__ + "static/media/logo.283e8356.png";